@if (project(); as p) {
  <section class="ficha">
    <!-- ===== Hero ===== -->
    <div class="ficha__hero ts-mosaic-band">
      <div class="ficha__wrap ficha__hero-grid">
        <div>
          <nav class="ficha__crumb">
            <a routerLink="/a-medida">Desarrollos a medida</a>
            <span class="ficha__crumb-sep">/</span>
            <span class="ficha__crumb-here">{{ p.title }}</span>
          </nav>
          <div class="ficha__eyebrow">
            <app-ts-piece piece="tr" variant="outline" color="var(--ts-primary)" [size]="17" />
            <span>Caso real · {{ p.tipo }}</span>
          </div>
          <h1 class="ficha__title">{{ p.ficha.heroTitle }}</h1>
          <p class="ficha__subtitle">{{ p.ficha.heroSubtitle }}</p>
          <div class="ficha__hero-cta">
            <a class="ts-btn ts-btn--dark" routerLink="/contacto">Cuéntanos tu caso</a>
            @if (p.ficha.solutionSlug) {
              <a
                class="ficha__hero-link"
                [routerLink]="['/soluciones', p.ficha.solutionSlug]"
                >Ver la solución de {{ p.ficha.sectorLabel }} →</a
              >
            }
          </div>
        </div>
        <div class="ficha__hero-media">
          <div
            class="ficha__hero-img"
            role="img"
            [attr.aria-label]="p.title"
            [style.background-image]="'url(' + p.ficha.heroImage + ')'"></div>
        </div>
      </div>
    </div>

    <!-- ===== Qué necesitaban / Qué montamos ===== -->
    <div class="ficha__wrap ficha__need">
      <div class="ficha-need">
        <span class="ficha-need__label ficha-need__label--muted">Qué necesitaban</span>
        <span class="ficha-need__text">{{ p.ficha.necesitaban }}</span>
      </div>
      <div class="ficha-need">
        <span class="ficha-need__label ficha-need__label--primary">Qué montamos</span>
        <span class="ficha-need__text">{{ p.ficha.montamos }}</span>
      </div>
    </div>

    <!-- ===== Lo que lleva dentro ===== -->
    <div class="ficha__dentro ts-mosaic-band">
      <div class="ficha__wrap">
        <h2 class="ficha__h2">Lo que lleva dentro</h2>
        <p class="ficha__h2-sub">{{ p.ficha.dentroIntro }}</p>
        <div class="ficha__pieces">
          <div class="ficha-piece">
            <app-ts-piece piece="full" color="var(--ts-primary)" [size]="26" />
            <span class="ficha-piece__name">Base Esencial</span>
            <span class="ficha-piece__desc">{{ p.ficha.baseDesc }}</span>
          </div>
          @for (m of p.ficha.modulos; track m.label) {
            <div class="ficha-piece">
              <app-ts-piece piece="tr" [color]="m.color" [size]="24" />
              <span class="ficha-piece__name">{{ m.label }}</span>
              <span class="ficha-piece__desc">{{ m.desc }}</span>
            </div>
          }
          <div class="ficha-piece ficha-piece--custom">
            <app-ts-piece piece="tr" variant="outline" color="var(--ts-primary)" [size]="24" />
            <span class="ficha-piece__name">{{ p.ficha.aMedida.label }}</span>
            <span class="ficha-piece__desc">{{ p.ficha.aMedida.desc }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== Capturas ===== -->
    <div class="ficha__wrap ficha__shots">
      <h2 class="ficha__h2">Así se ve por dentro</h2>
      <div class="ficha__shots-grid">
        @for (c of p.ficha.capturas; track c.image) {
          <figure class="ficha-shot">
            <div
              class="ficha-shot__img"
              role="img"
              [attr.aria-label]="c.caption"
              [style.background-image]="'url(' + c.image + ')'"></div>
            <figcaption class="ficha-shot__cap">{{ c.caption }}</figcaption>
          </figure>
        }
      </div>
    </div>

    <!-- ===== Resultado ===== -->
    <div class="ficha__result ts-mosaic-band">
      <div class="ficha__wrap ficha__result-inner">
        <span class="ficha__result-eyebrow">El cambio en su día a día</span>
        <span class="ficha__result-statement">{{ p.ficha.resultado }}</span>
        <span class="ficha__result-chip">Ejemplo · pendiente de testimonio real</span>
      </div>
    </div>

    <!-- ===== CTA final ===== -->
    <div class="ficha__wrap ficha__cta">
      <h2 class="ficha__cta-title">¿Tu caso se parece? Mejor aún si no.</h2>
      <p class="ficha__cta-text">
        Cuéntanoslo y te decimos qué resuelve ya el catálogo y qué pieza habría
        que construir.
      </p>
      <div class="ficha__cta-actions">
        <a class="ts-btn ts-btn--dark ts-btn--lg" routerLink="/contacto"
          >Cuéntanos tu caso</a
        >
        <a class="ficha__cta-back" routerLink="/a-medida"
          >← Todos los desarrollos a medida</a
        >
      </div>
    </div>
  </section>
} @else {
  <section class="ficha ficha--notfound">
    <div class="ficha__wrap">
      <h1 class="ficha__nf-title">Caso no encontrado</h1>
      <p>El caso que buscas no existe o ha cambiado de dirección.</p>
      <a class="ts-btn ts-btn--dark" routerLink="/a-medida">Ver desarrollos a medida</a>
    </div>
  </section>
}
